import { Button, Checkbox, Col, Input, message, Popconfirm, Row, Select } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
import { testProfile } from "./cancelFunction.js";
import SelectAccounts from "./selectAccounts.js";

function AddNewVisa(props) {
  const [loading, setLoading] = useState(false);
  const [profileModel, setProfileModel] = useState(testProfile);
  const [mccId, setMccId] = useState("");
  const [mccList, setMccList] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [needDisable, setNeedDisable] = useState(false);
  const [verifyDUNS, setVerifyDUNS] = useState(true);
  const [needVerifyPayment, setNeedVerifyPayment] = useState(true);
  const [manual, setManual] = useState(true);
  const [stopAtAddVISA, setStopAtAddVISA] = useState(false);
  // sheet Profile info
  const [sheetProfileURL, setSheetProfileURL] = useState('');
  const [sheetProfileName, setSheetProfileName] = useState('Trang Tính1');
  // sheet visa
  const [sheetURL, setSheetURL] = useState('');
  const [sheetName, setSheetName] = useState('Trang Tính1');

  const [quantity, setQuantity] = useState('5');

  const addVisa = async (profile) => {
    if (!sheetURL) {
      alert("Link GG Sheet VISA chưa nhập !!!")
      return;
    }
    if (!sheetProfileURL) {
      alert("Link GG Sheet Profile chưa nhập !!!")
      return;
    }
    messageApi.info(`Profile: ${profile.name} >>> Add visa new...`);
    let body = {
      profile: profile,
      sheet: {
        sheetId: sheetURL.split('/d/')[1].split('/edit')[0],
        sheetName: sheetName,
      },
      sheetProfile: {
        sheetId: sheetProfileURL.split('/d/')[1].split('/edit')[0],
        sheetName: sheetProfileName,
      },
      quantity,
      verifyDUNS,
      mccId: mccList?.length > 0 ? mccList[0] : mccId,
      site: (props.site ?? 'local') == 'MCC' ? 'internal' : 'local',
      needDisable,
      needVerifyPayment,
      manual,
      stopAtAddVISA,
    };
    axios
      .post(`${API_HOST}/api/add-new-visa`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ add-new-visa ~ e:", e);
        messageApi.error(e.response.data);
      });
  };

  useEffect(() => {
    let sheetName = localStorage.getItem('mcc-sheetName')
    if (sheetName) {
      setSheetName(sheetName)
    }
    let sheetURL = localStorage.getItem('mcc-sheetURL')
    if (sheetURL) {
      setSheetURL(sheetURL)
    }
    let sheetProfileURL = localStorage.getItem('mcc-sheetProfileURL')
    if (sheetProfileURL) {
      setSheetProfileURL(sheetProfileURL)
    }
    let sheetProfileName = localStorage.getItem('mcc-sheetProfileName')
    if (sheetProfileName) {
      setSheetProfileName(sheetProfileName)
    }
    let quantity = localStorage.getItem('mcc-quantity')
    if (quantity) {
      setQuantity(quantity)
    }
    let stopAtAddVISA = localStorage.getItem('mcc-stopAtAddVISA')
    if (stopAtAddVISA) {
      setStopAtAddVISA(stopAtAddVISA === 'true')
    }
    let verifyDUNS = localStorage.getItem('mcc-duns')
    if (verifyDUNS) {
      setVerifyDUNS(verifyDUNS === 'true')
    }
  })

  const onOpenChange = (open) => {
    if (open) {
      setLoading(true);
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          setLoading(false);
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          setLoading(false);
          messageApi.error("Không thể lấy thông tin Profile");
        });
    }
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ width: '800px' }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Add Visa Mới"
        description={
          <div style={{ width: '800px' }}>
            {profileModel?.errorMsg?.length > 0 && (
              <label style={{ color: "red", border: "1px solid red" }}>
                <strong>{profileModel?.errorMsg}</strong>
              </label>
            )}

            <label>Nhập MCC ID (Nếu có nhiều TK MCC):</label>
            <br />
            <Input
              style={{ width: 300 }}
              placeholder="MCC ID"
              onChange={(e) => setMccId(e.target.value)}
            />
            <SelectAccounts selectAccounts={profileModel?.selectAccounts} max={1}
              onSelected={(selected) => setMccList(selected)}
            />
            <br />
            <br />
            <Checkbox checked={needDisable} onChange={e => setNeedDisable(e.target.checked)}>
              Hủy TK Sau Khi Add
            </Checkbox>
            <br />
            <Checkbox checked={needVerifyPayment} onChange={e => setNeedVerifyPayment(e.target.checked)}>
              Xác Minh VISA
            </Checkbox>
            <br />
            <Checkbox checked={manual} onChange={e => setManual(e.target.checked)}>
              Lấy CODE Thủ Công
            </Checkbox>
            <br />
            <Checkbox checked={!stopAtAddVISA} onChange={e => {
              setStopAtAddVISA(!e.target.checked)
              localStorage.setItem("mcc-stopAtAddVISA", `${!e.target.checked}`);
            }}>
              SUBMIT : Sau Khi thêm VISA
            </Checkbox>
            <br />
            <Checkbox checked={verifyDUNS} onChange={e => {
              setVerifyDUNS(e.target.checked)
              localStorage.setItem("mcc-duns", e.target.checked + '');
            }}>
              Xác Minh D.U.N.S
            </Checkbox>
            <br />
            <Row>
              <Col span={4}>
                <label>Số Lượng TK: </label>
              </Col>
              <Col span={20}>
                <Input
                  value={quantity}
                  type="number"
                  style={{ width: 60 }}
                  placeholder="Số Lượng ..."
                  onChange={(e) => {
                    setQuantity(e.target.value)
                    localStorage.setItem("mcc-quantity", e.target.value);
                  }}
                />
              </Col>
            </Row>
            <b style={{ color: 'red' }}>GG sheet VISA: </b>
            <Row>
              <Col span={2}>
                <label>URL: </label>
              </Col>
              <Col span={22}>
                <Input
                  value={sheetURL}
                  style={{ width: 400 }}
                  placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                  onChange={(e) => {
                    setSheetURL(e.target.value);
                    localStorage.setItem('mcc-sheetURL', e.target.value);
                  }}
                />
              </Col>
              <Col span={2}>
                <label>Trang: </label>
              </Col>
              <Col span={22}>
                <Input
                  value={sheetName}
                  style={{ width: 200 }}
                  placeholder="SheetName visa..."
                  onChange={(e) => {
                    setSheetName(e.target.value);
                    localStorage.setItem('mcc-sheetName', e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br></br>
            <b style={{ color: 'blue' }}>GG sheet Profile <i>(Cột I: Quốc Gia -{'>'} Lấy theo Quốc Gia của VISA)</i>: </b>
            <Row>
              <Col span={2}>
                <label>URL: </label>
              </Col>
              <Col span={22}>
                <Input
                  value={sheetProfileURL}
                  style={{ width: 400 }}
                  placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                  onChange={(e) => {
                    setSheetProfileURL(e.target.value);
                    localStorage.setItem('mcc-sheetProfileURL', e.target.value);
                  }}
                />
              </Col>
              <Col span={2}>
                <label>Trang: </label>
              </Col>
              <Col span={22}>
                <Input
                  value={sheetProfileName}
                  style={{ width: 200 }}
                  placeholder="SheetName profile..."
                  onChange={(e) => {
                    setSheetProfileName(e.target.value);
                    localStorage.setItem('mcc-sheetProfileName', e.target.value);
                  }}
                />
              </Col>
            </Row>
          </div>
        }
        onConfirm={() => addVisa(props.profile)}
      >
        <Button danger loading={loading}>
          Add Visa {props.site ?? 'local'}
        </Button>
      </Popconfirm>
    </>
  );
}
export default AddNewVisa;
